import { EventDate } from 'app/shared/types/event-date';

export const formatEventDateRange = (startDate: EventDate, endDate: EventDate): string => {
  const daysDoNotMatch = startDate.eventDateDayDD !== endDate.eventDateDayDD;
  const monthsDoNotMatch = startDate.eventDateMonthNumMM !== endDate.eventDateMonthNumMM;
  let dateRange = null;

  if (daysDoNotMatch || monthsDoNotMatch) {
    dateRange = `${startDate.fullDate} - ${endDate.fullDate}`;
  } else {
    dateRange = startDate.fullDate;
  }

  return dateRange;
};
